export const ApiResources = {
  ACCESS_TOKEN: 'auth',
  REFRESH_TOKEN: 'refresh-token',
  USERS: 'users',
  SIGNUP: 'signup',
  SKILLS: 'skills',
  DRIVERS: 'drivers',
  CITIES: 'cidades',
  VEHICLES: 'grupoveiculos',
  CLIENTS: 'clientes',
  CLIENTS_CPF: 'clientes/cpf',
  CLIENTS_PASSAPORT: 'clientes/passaporte',
  RESERVA: 'reservas',
  RESERVA_CUPOM: 'reservas/cupom-descontos',
  PARAMETROS: 'portal-reservas/parametros',
  CLIENTES_CODIGO: 'clientes/codigo',
  API_SECUNDARIAS: 'endpoint-api-secundarias',
  GET_API_SECUNDARIAS: 'api-secundarias',
  PARAMETERS: 'reservas/parametros-locacao',
  INTERNATIONALIZATION: 'configuracao-internacionalizacao',
  COUNTRY: 'paises',
  MUNICIPIOS: 'municipios',
  TIPOSENDERECO: 'clientes/tipo-endereco'
};
